"use client"

import { useCallback, useState } from "react"
import { useNavigate } from "react-router-dom"
import { Box, Flex, Text } from "@chakra-ui/react"
import { FaUserTie, FaRoute } from "react-icons/fa"

import Rep from "./Rep"
import RepTracker from "../field/RepTracker"
import { usePageAccess } from "../../wrappers/PageAccessContext"
import { neutral, brand, type } from "../../theme/tokens"

/**
 * Rep Sales & Routing (2026-10-12, Helena — "combine the Rep Sales & Rep Routing section, all of it in one screen").
 * Rep Sales (sales at cost per rep, Dischem) on top, Rep Routing (strike rate, visits, road km) under it, each with
 * its own filters and Excel. One line per rep: the All reps table carries the rep's routing columns too (Scheduled …
 * Days + Route) — RepTracker hands its summary up through onSummary, and drops its own Per rep tab when embedded.
 * The Sales at cost by rep chart sits at the foot of the page (Helena: "remove this image, or put it at the bottom").
 * Access per part: Rep Sales hides for a restricted account (the old menu item's `restrictable`); Rep Routing
 * renders nothing when the server does not treat the login as a routing admin (masters edit, org admin / CAM with
 * the RepRouting grant view) — then the table has no routing columns either.
 */
const Heading = ({ icon, title, accent }) => (
  <Flex align="center" gap={2} mb={3} mt={2}>
    <Box as={icon} color={accent} boxSize="16px" />
    <Text fontSize={type.size.body} fontWeight={type.weight.semibold} color={neutral[800]} letterSpacing="0.02em">{title}</Text>
    <Box flex="1" h="1px" bg={neutral[200]} ml={2} />
  </Flex>
)

const RepHub = () => {
  const { restrictedyn } = usePageAccess()
  const navigate = useNavigate()
  const [routing, setRouting] = useState(null)
  const [chartTarget, setChartTarget] = useState(null)
  const onRoute = useCallback((rep) => navigate(`/field/route?rep=${encodeURIComponent(rep)}`), [navigate])

  return (
    <Box>
      {!restrictedyn && (
        <Box mb={8}>
          <Heading icon={FaUserTie} title="Rep Sales" accent={brand[500]} />
          <Rep routing={routing} onRoute={onRoute} chartTarget={chartTarget} />
        </Box>
      )}
      <RepTracker embedded onSummary={setRouting} header={<Heading icon={FaRoute} title="Rep Routing" accent="#2B6CB0" />} />
      {!restrictedyn && (
        <Box mt={8} ref={setChartTarget} maxW="900px" />
      )}
    </Box>
  )
}

export default RepHub
